import React from "react";
import Footer from "../../components/footer";
import FAQs from "./components/faqs/FAQs";
import Beneficiaries from "./components/beneficiaries/Beneficiaries";
import SMEsInAfrica from "./components/smes-in-africa/SMEsInAfrica";
import BenefitsFrom1KB from "./components/benefits-from-1kb/BenefitsFrom1KB";
import AboutEratek1KB from "./components/about-eratek-1kb/AboutEratek1KB";
import Eratek1KBHero from "./components/eratek-1kb-hero/Eratek1KBHero";
import Eratek1KBNavbar from "./components/era-tek-1kb-navbar/Eratek1KBNavbar";
import "./Initiatives.css";







export default function OneKBInitiative() {

  return (
    <div
      className="OneKBInitiative-wrapper"
    >
      <Eratek1KBNavbar />
      <Eratek1KBHero />
      <AboutEratek1KB />
      <BenefitsFrom1KB />
      <SMEsInAfrica />
      <Beneficiaries />
      <FAQs />
      <Footer />
    </div>
  );
}

